export default {
  '--popup-content-background-color': '#1e1e1e'
};